var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mb-5 last:mb-0 w-full",
      class: _vm.handleClasses(_vm.type),
      attrs: { "data-type": _vm.type }
    },
    [
      _vm.type === "checkbox"
        ? [
            _c(
              "checkbox",
              {
                attrs: {
                  id: _vm.id,
                  "is-required": _vm.isRequired,
                  value: _vm.value
                },
                on: {
                  inputWasChanged: function($event) {
                    return _vm.handleExternalValidation($event)
                  },
                  input: function($event) {
                    return _vm.handleInput($event)
                  }
                }
              },
              [_c("span", { domProps: { innerHTML: _vm._s(_vm.label) } })]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "time"
        ? [
            _c("vpf-select", {
              attrs: {
                placeholder: _vm.placeholder,
                "is-required": _vm.isRequired,
                label: _vm.label,
                value: _vm.value
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event)
                },
                inputWasChanged: function($event) {
                  return _vm.handleExternalValidation($event)
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.inputType === "label"
        ? [
            _c("div", {
              staticClass:
                "text-editor relative text-left md:text-center text-base md:text-xl md:mt-6",
              attrs: { role: "heading", "aria-level": "2" },
              domProps: { innerHTML: _vm._s(_vm.label) }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "textarea"
        ? [
            _vm.label
              ? _c(
                  "div",
                  { staticClass: "text-base mb-2 flex w-auto items-start" },
                  [
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
                    _vm._v(" "),
                    _vm.isRequired
                      ? _c("span", { staticClass: "text-velux-red ml-0.5" }, [
                          _vm._v("*")
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model[_vm.inputType],
                  expression: "model[inputType]"
                }
              ],
              ref: "focusInput",
              staticClass:
                "\n        px-4\n        w-full\n        py-3.5\n        md:p-3\n        text-base\n        md:text-lg\n        border\n        placeholder-velux-grey-300\n        font-bold\n      ",
              class: {
                "border-velux-red": _vm.hasError()
              },
              attrs: {
                name: _vm.name,
                required: _vm.isRequired,
                placeholder: _vm.placeholder,
                id: _vm.id,
                rows: "5"
              },
              domProps: { value: _vm.model[_vm.inputType] },
              on: {
                blur: function($event) {
                  return _vm.handleValidation({ isBlur: true })
                },
                keyup: function($event) {
                  return _vm.handleValidation()
                },
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.model, _vm.inputType, $event.target.value)
                  },
                  function($event) {
                    return _vm.handleInput($event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.hasError() && _vm.errorMessage
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text-velux-red mt-1 font-bold text-left text-base"
                  },
                  [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "file"
        ? [
            _c(
              "file-upload",
              {
                attrs: {
                  "is-required": _vm.isRequired,
                  label: _vm.label,
                  id: _vm.id,
                  name: _vm.name
                },
                on: {
                  inputWasChanged: function($event) {
                    return _vm.handleExternalValidation($event)
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(_vm.placeholder) + "\n    ")]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isExternalInput &&
      _vm.inputType !== "label" &&
      _vm.inputType !== "textarea"
        ? [
            _vm.label
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text-base font-normal mb-2 flex w-auto items-start"
                  },
                  [
                    _c("span", { domProps: { innerHTML: _vm._s(_vm.label) } }),
                    _vm._v(" "),
                    _vm.isRequired
                      ? _c("span", { staticClass: "text-velux-red ml-0.5" }, [
                          _vm._v("*")
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.inputType === "checkbox"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model[_vm.inputType],
                      expression: "model[inputType]"
                    }
                  ],
                  ref: "focusInput",
                  staticClass:
                    "\n        px-4\n        w-full\n        py-3.5\n        md:p-3\n        text-base\n        md:text-lg\n        border\n        placeholder-velux-grey-300\n        font-bold\n      ",
                  class: {
                    "border-velux-red": _vm.hasError()
                  },
                  attrs: {
                    required: _vm.isRequired,
                    placeholder: _vm.placeholder,
                    name: _vm.name,
                    id: _vm.id,
                    type: "checkbox"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.model[_vm.inputType])
                      ? _vm._i(_vm.model[_vm.inputType], null) > -1
                      : _vm.model[_vm.inputType]
                  },
                  on: {
                    blur: function($event) {
                      return _vm.handleValidation({ isBlur: true })
                    },
                    keyup: function($event) {
                      return _vm.handleValidation()
                    },
                    input: function($event) {
                      return _vm.handleInput($event)
                    },
                    change: function($event) {
                      var $$a = _vm.model[_vm.inputType],
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.model,
                              _vm.inputType,
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.model,
                              _vm.inputType,
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.model, _vm.inputType, $$c)
                      }
                    }
                  }
                })
              : _vm.inputType === "radio"
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model[_vm.inputType],
                      expression: "model[inputType]"
                    }
                  ],
                  ref: "focusInput",
                  staticClass:
                    "\n        px-4\n        w-full\n        py-3.5\n        md:p-3\n        text-base\n        md:text-lg\n        border\n        placeholder-velux-grey-300\n        font-bold\n      ",
                  class: {
                    "border-velux-red": _vm.hasError()
                  },
                  attrs: {
                    required: _vm.isRequired,
                    placeholder: _vm.placeholder,
                    name: _vm.name,
                    id: _vm.id,
                    type: "radio"
                  },
                  domProps: { checked: _vm._q(_vm.model[_vm.inputType], null) },
                  on: {
                    blur: function($event) {
                      return _vm.handleValidation({ isBlur: true })
                    },
                    keyup: function($event) {
                      return _vm.handleValidation()
                    },
                    input: function($event) {
                      return _vm.handleInput($event)
                    },
                    change: function($event) {
                      return _vm.$set(_vm.model, _vm.inputType, null)
                    }
                  }
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model[_vm.inputType],
                      expression: "model[inputType]"
                    }
                  ],
                  ref: "focusInput",
                  staticClass:
                    "\n        px-4\n        w-full\n        py-3.5\n        md:p-3\n        text-base\n        md:text-lg\n        border\n        placeholder-velux-grey-300\n        font-bold\n      ",
                  class: {
                    "border-velux-red": _vm.hasError()
                  },
                  attrs: {
                    required: _vm.isRequired,
                    placeholder: _vm.placeholder,
                    name: _vm.name,
                    id: _vm.id,
                    type: _vm.inputType
                  },
                  domProps: { value: _vm.model[_vm.inputType] },
                  on: {
                    blur: function($event) {
                      return _vm.handleValidation({ isBlur: true })
                    },
                    keyup: function($event) {
                      return _vm.handleValidation()
                    },
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.model, _vm.inputType, $event.target.value)
                      },
                      function($event) {
                        return _vm.handleInput($event)
                      }
                    ]
                  }
                }),
            _vm._v(" "),
            _vm.hasError() && _vm.errorMessage
              ? _c(
                  "div",
                  {
                    staticClass:
                      "text-velux-red mt-1 font-bold text-left text-base"
                  },
                  [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }